<template>
	<div class="color">
		<span v-for="(bin, index) in formBins"
			v-if="bin > 0"
			:key="index"
			:style="{
				width: binWidth(bin, colorTotal),
				background: getBackground(index)
			}">
			<div class="image">
				<img :src="formImage(index + 1)">
			</div>
			<label>
				{{ binLabel(bin, colorTotal) }}
			</label>
		</span>
	</div>
</template>
<script>
import ExcretionAnalysis from '..'

export default {
	name: 'lifestyle-table-form-column',
	extends: ExcretionAnalysis,

	methods: {
		getBackground(index) {
			var c = (200 + index * 7)
			return 'rgb(' + c + ',' + c + ',' + c + ')'
		}
	}
}
</script>

<style lang="scss" scoped>

.color {
	height: 32px;
	> span {
		position: relative;
		float: left;
		height: 12px;
		margin-top: 18px;

		.image, label {
			position: absolute;
			left: 0px;
			width: 100%;
			text-align: center;
		}

		.image {
			bottom: 6px;
			overflow: visible;
			white-space: nowrap;

			img {
				width: 16px;
				height: 16px;
			}
		}
		label {
			color: #3f3f3f;
			bottom: -6px;
			font-size: 10px;
			font-weight: 700;
			letter-spacing: 1px;
		}
	}
}
</style>
